module.exports = __webpack_public_path__ + "img/infography-1.cc4aa6b7.webp";